function loadYoutubeAPIAsync(){
  var tag = document.createElement('script');

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

(function($){
  $(function(){
    var player;
    loadYoutubeAPIAsync()
    $(".youtube").each(function() {
        // Overlay the Play icon to make it look like a video player
        var playDiv = $('<div></div>', {
          'class': 'play',
          'role': 'button',
          'tabindex': '0',
          'aria-label': 'Click to play lesson: ' + LESSON_DETAILS.name
        })
        $(this).append(playDiv);

        $(document).delegate('#' + this.id, 'click', function() {
          var youtubeId = $(this).attr('id');
          var width = $(this).width();
          var height = $(this).height();  // Not used for now

          player = new YT.Player(youtubeId, {
            width: width,
            videoId: youtubeId,
            playerVars: {
              rel: 0,
              controls: 2,
              showinfo: 0
            },
            events: {
              'onReady': function(event){
                event.target.playVideo();
              }
            }
          });
        });
    });
    $('.js-youtube-seek-to').on('click', function(evt){
      evt.preventDefault();
      var seconds = parseInt($(this).data('seek-to-second'));
      if(seconds >= 0){
        player.seekTo(seconds, true);
      }
    })
  }); // end of document ready
})(jQuery); // end of jQuery name space
